import { Box, Button, Flex, Table, TableContainer, Tbody, Td, Tr } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import TableActions from '../../common/TableActions/TableActions';
import TableHeader from '../../common/TableHeader/TableHeader';
import useItemLister from '../../core/hooks/useItemLister';
import { IQuestion } from '../../core/models';

const FILTERS = ['question'];
const COLS: {
  label: string;
  sort?: string;
  isNumeric?: boolean;
}[] = [
  {
    label: 'Question',
    sort: 'question',
  },
  {
    label: 'Actions',
    isNumeric: true,
  },
];

function QuestionLister() {
  const navigate = useNavigate();
  const { items, deleteItem, deleteLoading, Lister, activeId, sort, changeSort, setIsActive } =
    useItemLister({
      endpointSingle: 'life_question',
      endpointPlural: 'life_questions',
      filters: FILTERS,
    });

  useEffect(() => {
    setIsActive(true);

    return () => {
      setIsActive(false);
    };
  }, []);

  return (
    <Flex flexDirection="column">
      <Flex justifyContent="space-between" width="100%">
        <h1 className="h3">Life questions</h1>
        <Button
          colorScheme="messenger"
          type="button"
          shadow="lg"
          ml="auto"
          onClick={() => navigate(`/new-life-question`)}
        >
          Create a new life question
        </Button>
      </Flex>
      {Lister({
        children: (
          <Box my={5}>
            <TableContainer fontSize="1rem" boxShadow="xl">
              <Table variant="striped" colorScheme="facebook">
                <TableHeader sort={sort} changeSort={changeSort} cols={COLS} />
                <Tbody>
                  {items?.map((lifeQuestion: IQuestion) => (
                    <Tr key={lifeQuestion._id}>
                      <Td py={3} verticalAlign="middle">
                        <button
                          style={{
                            padding: '6px',
                            maxWidth: '600px',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                          }}
                          type="button"
                          onClick={() => navigate(`/life-question/${lifeQuestion._id}`)}
                        >
                          {lifeQuestion.question}
                        </button>
                      </Td>
                      <Td py={3} verticalAlign="middle">
                        <TableActions
                          item={lifeQuestion}
                          path="life question"
                          activeId={activeId}
                          deleteItem={deleteItem}
                          deleteLoading={deleteLoading}
                          customEditUrl={`/life-question/${lifeQuestion._id}`}
                        />
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        ),
      })}
    </Flex>
  );
}

export default QuestionLister;
